module.exports = __webpack_public_path__ + "media/images/calendar-d933ce9f6b54835845b4f5503cf4a183.svg";